<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.c_number }}件商品</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper">
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="num-wrapper">
              <div class="name line1">{{ cartInfo.articlename }}</div>
              <div class="attr line1">
                {{ cartInfo.name }}
              </div>
            </div>
            <div>
              <div class="num">x {{ cartInfo.c_number }}</div>
              <div class="money font-color-red">￥{{ cartInfo.c_price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Object,
      default: () => []
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>

<style scoped>
.orderGoods .text {
  width: 100%;
}
</style>
